module.exports = __webpack_public_path__ + "img/bus_sidebar_img.7b2fea0e.png";